// Delivery fee calculator: flat for GTA, distance-tiered for outside-GTA Ontario,
// and a higher flat rate for out-of-province.

const GTA_CITIES = [
  'toronto', 'mississauga', 'brampton', 'hamilton', 'markham', 'vaughan', 'richmond hill',
  'oakville', 'burlington', 'pickering', 'ajax', 'whitby', 'oshawa', 'newmarket', 'aurora',
  'georgina', 'king', 'whitchurch-stouffville', 'caledon', 'halton hills', 'milton',
  'north york', 'scarborough', 'etobicoke', 'york',
];

// Tier 1 (~75–150km from GTA): $450
const TIER_1_CITIES = [
  'guelph', 'kitchener', 'waterloo', 'cambridge', 'brantford', 'barrie', 'orillia',
  'orangeville', 'st. catharines', 'st catharines', 'niagara falls', 'welland', 'fort erie',
  'grimsby', 'fonthill', 'thorold', 'beamsville', 'collingwood', 'wasaga beach',
];

// Tier 2 (~150–300km from GTA): $650
const TIER_2_CITIES = [
  'london', 'kingston', 'peterborough', 'belleville', 'cobourg', 'port hope', 'sarnia',
  'owen sound', 'gravenhurst', 'bracebridge', 'huntsville', 'parry sound', 'lindsay',
  'trenton', 'quinte west', 'stratford', 'woodstock', 'tillsonburg', 'simcoe',
];

// Tier 3 (300km+): $950
const TIER_3_CITIES = [
  'ottawa', 'sudbury', 'north bay', 'windsor', 'chatham', 'sault ste. marie', 'sault ste marie',
  'thunder bay', 'timmins', 'kapuskasing', 'kenora', 'cornwall', 'pembroke', 'brockville',
];

const normalize = (city: string) => city.toLowerCase().trim();

export const isWithinGTA = (city: string, province: string): boolean => {
  if (province !== 'ON') return false;
  return GTA_CITIES.includes(normalize(city));
};

export const calculateDeliveryFee = (city: string, province: string): number => {
  if (!city || !province) return 0;
  const c = normalize(city);

  // Out-of-province
  if (province !== 'ON') return 950;

  if (GTA_CITIES.includes(c)) return 325;
  if (TIER_1_CITIES.includes(c)) return 450;
  if (TIER_2_CITIES.includes(c)) return 650;
  if (TIER_3_CITIES.includes(c)) return 950;

  // Unknown Ontario city — middle tier as a safe default
  return 650;
};
